var BASWebServices;
(function (BASWebServices) {
    var ClarinIFrameController = (function () {
        function ClarinIFrameController($scope, wsData, cfgService, browserService) {
            this.$scope = $scope;
            this.wsData = wsData;
            this.cfgService = cfgService;
            this.browserService = browserService;
            this.setNavBarState = function (showNavBar) {
                this.cfgService.showNavBar = showNavBar;
            };
            $scope.cifc = this;
            wsData.setServiceName("runMAUSBasic");
            cfgService.showNavBar = false;
            if (browserService.getBrowserType() != "chrome" && browserService.getBrowserType() != "firefox") {
                this.$scope.unsupportedBrowser = true;
            }
        }
        return ClarinIFrameController;
    }());
    BASWebServices.ClarinIFrameController = ClarinIFrameController;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=ClarinIFrameController.js.map